// Cotización y aplicación del abono a capital desde el expediente (permiso `loan.credit.prepay`).
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { loanCreditApi } from '@/api/services/loan-credit';

/** Raíz de las lecturas del expediente: crédito, plan, pagos, contratos y la cotización. */
const CREDIT_FILE_KEY = ['credit-file'] as const;

const QUOTE_KEY = [...CREDIT_FILE_KEY, 'prepayment-quote'] as const;

/** La cotización se pide al abrir el diálogo y no se guarda: el saldo cambia con cada pago. */
export function usePrepaymentQuote(creditId: string) {
    return useQuery({
        queryKey: [...QUOTE_KEY, creditId],
        queryFn: () => loanCreditApi.getPrepaymentQuote(creditId),
        staleTime: 0,
        gcTime: 0,
        retry: false,
        refetchOnWindowFocus: false,
    });
}

/**
 * Pide el abono. Haya salido bien o mal, refresca el expediente: un 502 del motor pudo dejar el
 * cobro en curso, y el operador no debe reintentar sobre cifras viejas.
 */
export function useApplyPrepayment(creditId: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (amountCents: number) =>
            loanCreditApi.applyPrepayment(creditId, { amountCents }),
        onSettled: () => queryClient.invalidateQueries({ queryKey: CREDIT_FILE_KEY }),
    });
}
